// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-form-div[data-v-80e03bcc]{padding:20px}.form-bottom[data-v-80e03bcc]{text-align:center;border-top:1px solid hsla(0,0%,60%,.5);padding-top:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
